import React from 'react';
import useQuranReader from '../hooks/useQuranReader';

const ProgressBar = () => {
  const { 
    totalProgress, 
    surahProgress, 
    currentVerse, 
    currentSurahTotalVerses 
  } = useQuranReader();

  return (
    <div className="mb-6 space-y-4">
      <div>
        <div className="flex justify-between text-sm mb-1 font-lato">
          <span className="text-heading">Surah Progress</span>
          <span className="font-medium" style={{ color: 'var(--color-charcoal)' }}>{currentVerse}/{currentSurahTotalVerses}</span>
        </div>
        <div className="w-full rounded-full h-2" style={{ backgroundColor: 'var(--color-light-gray)' }}>
          <div 
            className="bg-medium-green h-2 rounded-full transition-all duration-300" 
            style={{ width: `${surahProgress}%` }}
          ></div>
        </div>
      </div>
      
      <div>
        <div className="flex justify-between text-sm mb-1 font-lato">
          <span className="text-heading">Total Quran Progress</span>
          <span className="font-medium" style={{ color: 'var(--color-charcoal)' }}>{Math.round(totalProgress)}%</span>
        </div>
        <div className="w-full rounded-full h-2" style={{ backgroundColor: 'var(--color-light-gray)' }}>
          <div 
            className="bg-gold h-2 rounded-full transition-all duration-300" 
            style={{ width: `${totalProgress}%` }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;